<template>
	<div class="row">
		<div class="col-md-12">
			<comments
				v-if="user.hasRole(['manager', 'admin', 'staff', 'external_manager'])"
				@reload="reload"
				:resource="'admin/projects/projects/' + item.id"
				:user="user"
				:isAuth="isAuth">
			</comments>
		</div>
	</div>
</template>

<script>
	import Comments from '@/components/cms/comments/layout/Comments.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'comments': Comments,
		},
		data () {
			return {
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
			},
			reload() {
				this.$emit('reload')
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Comments.vue